import { createSlice } from '@reduxjs/toolkit';

const defaultCallEnvironment = {
    toNumber: '',
    initialContactNumber: '',
    isCallInProgress: false,
    callStatus: 'DIALING',
    updateInitialContact: false,
    isCallReceived: false,
    isCallHold: false,
    isTransferring: false,
    incomingCallConnection: null,
    incomingCallContact: null,
    activeContact: null,
    dialerNumber: '',
    callInfo: {
        firstCallSid: '',
        secondCallSid: '',
        conferenceSid: '',
    },
    callRecordingStatus: 'stopped',
    callRecordInstance: 0,
};

const transferCallEnvironment = {
    toNumber: '',
    isCallInProgress: false,
    callStatus: 'DIALING',
    isCallReceived: false,
    isCallHold: false,
    activeContact: null,
    dialerNumber: '',
    transferToUser: null,
    transferType: null
};

const initialState = {
    loadingContacts: false,
    contacts: [],

    loadingVirtualNumbers: false,
    virtualNumbers: [],

    loadingTeamMembers: false,
    teamMembers: [],

    lastCaller: null,
    lastCallTime: 0,

    callEnvironment: {
        fromNumber: '',
        ...defaultCallEnvironment
    },
    transferCallEnvironment: {
        ...transferCallEnvironment
    }
};

const globalDialerSlice = createSlice({
    name: 'globalDialerV2',
    initialState,
    reducers: {
        searchContactsStart: (state, action) => {
            state.loadingContacts = true;
        },
        searchContactsSuccess: (state, action) => {
            state.loadingContacts = false;
            state.contacts = action.payload
        },
        searchContactsFail: (state) => {
            state.loadingContacts = false;
        },

        resetContacts: (state) => {
          state.contacts = [];
        },

        getVirtualNumbersStart: (state, action) => {
            state.loadingVirtualNumbers = true;
        },
        getVirtualNumbersSuccess: (state, action) => {
            state.loadingVirtualNumbers = false;
            state.virtualNumbers = action.payload;
        },
        getVirtualNumbersFail: (state) => {
            state.loadingVirtualNumbers = false;
        },

        getTeamMembersStart: (state, action) => {
            state.loadingTeamMembers = true;
        },
        getTeamMembersSuccess: (state, action) => {
            state.loadingTeamMembers = false;
            state.teamMembers = action.payload;
        },
        getTeamMembersFail: (state) => {
            state.loadingTeamMembers = false;
        },

        setCallEnvironment: (state, action) => {
            state.callEnvironment = { ...state.callEnvironment, ...action.payload };
        },

        setCallInfo: (state, action) => {
            state.callEnvironment.callInfo = {
                ...state.callEnvironment.callInfo,
                ...action.payload
            };
        },

        resetCallEnvironment: (state, action) => {
            const forceReset = action.payload ?? {};
            state.callEnvironment = { ...state.callEnvironment, ...defaultCallEnvironment,  ...forceReset };
            state.transferCallEnvironment = { ...state.transferCallEnvironment, ...transferCallEnvironment };
        },

        setTransferCallEnvironment: (state, action) => {
            state.transferCallEnvironment = { ...state.transferCallEnvironment, ...action.payload };
        },

        setGlobalDialerState: (state, action) => {
            return { ...state, ...action.payload };
        },
    },
});

export const {
    searchContactsStart,
    searchContactsSuccess,
    searchContactsFail,
    resetContacts,
    getVirtualNumbersStart,
    getVirtualNumbersSuccess,
    getVirtualNumbersFail,

    getTeamMembersStart,
    getTeamMembersSuccess,
    getTeamMembersFail,

    setCallEnvironment,
    setCallInfo,
    resetCallEnvironment,

    setTransferCallEnvironment,
    setGlobalDialerState
} = globalDialerSlice.actions;

export default globalDialerSlice.reducer;
